import { jsx as _jsx } from "react/jsx-runtime";
import "./FollowsYou.css";
import { useIntl } from "react-intl";
import messages from "./messages";
export default function FollowsYou({ followsMe }) {
    const { formatMessage } = useIntl();
    return followsMe ? _jsx("span", { className: "follows-you", children: formatMessage(messages.FollowsYou) }) : null;
}
